import PublicError404Page from "./PublicError404Page";

export default PublicError404Page;
